<template>
    <div>
        <section class="xlrclh">
            <img class="top-img" src="./../assets/imgs/67/title-bg.png" alt="" />
            <div class="technological-process">
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/67/title-1.png" alt="" />
                    <div class="content" style="font-weight: bold">
                        在崇州市工作1年以上，工作能力或专业技能突出，在经济社会发展一线作出较大贡献人才
                    </div>
                </div>
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/67/title-2.png" alt="" />
                    <div class="content">
                        申报人选具体条件，详见《崇州市有突出贡献的拔尖人才选拔和管理办法》第六条的规定。
                    </div>
                </div>
                <div class="zccl">
                    <img class="top" src="./../assets/imgs/27/title-3.png" alt="" />
                    <div class="content">
                        <div class="des">
                            <div class="title">一. 资金支持</div>
                            （一）三年管理服务期内，享受总计12万元（4万元/年）的特殊津贴；其研究成果被市委、市政府采纳的另给予适当奖励。
                        </div>
                        <div class="des">
                            <div class="title">二. 职称申报</div>
                            在评聘专业技术职务时，同等条件下拔尖人才优先；同等条件下优先推荐提名拔尖人才为各级党代表、人大代表和政协委员人选。
                        </div>
                        <div class="des">
                            <div class="title">三. 交流培训</div>
                            （一）可参加市委市政府每年组织举办的拔尖人才座谈会及走访慰问活动。
                        </div>
                        <div class="des">
                            <div class="title">四. 体检疗养</div>
                            每年组织进行一次全面体检，建立拔尖人才健康档案，适时组织拔尖人才短期休假疗养。
                        </div>
                        <div class="des" style="text-align: center">
                            <div class="title">五. 其它</div>
                            可享受崇州人才绿卡相应待遇。
                        </div>
                    </div>
                </div>
                <div class="sbcl">
                    <img class="top" src="./../assets/imgs/67/title-4.png" alt="" />
                    <div class="content">
                        <div class="des">
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">1</div>
                                <div class="label">印发选拨通知</div>
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">2</div>
                                <div class="label">推荐</div>
                                <div style="
                                            line-height: 0.44rem;
                                            margin-top: 0.22rem;
                                        ">
                                    1.单位推荐<br />
                                    2.专家推荐<br />
                                    3.个人自荐
                                </div>
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">3</div>
                                <div class="label">
                                    市委人才办会同相关部门初审
                                </div>
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">4</div>
                                <div class="label">
                                    市委人才办牵头组织评审会评审
                                </div>
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">5</div>
                                <div class="label">
                                    市委人才办牵头组织考察组考察
                                </div>
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">6</div>
                                <div class="label">公示</div>
                            </div>
                            <div class="item">
                                <div class="dot">7</div>
                                <div class="label">命名</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/67/title-5.png" alt="" />
                    <div class="content" style="font-weight: bold">
                        拔尖人才的评选工作每3年进行一次，以每批次申报通知时间为准。
                    </div>
                </div>
                <div class="contact">
                    <img class="top" src="./../assets/imgs/67/title-6.png" alt="" />
                    <div class="content">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-82228953">028-82228953</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            中共崇州市委组织部人才工作科
                        </div>
                    </div>
                </div>
                <div class="codes">
                    <img class="code" src="../assets/imgs/67/code.png" />
                    <img class="text" src="../assets/imgs/67/text.png" />
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import call from "../components/call.vue";
export default {
    data() {
        return {};
    },

    components: {
        call,
    },

    mounted() { },

    methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
    background-color: $base-back;

    .top-img {
        width: 7.26rem;
        height: 5.64rem;
    }

    .technological-process {
        transform: translateY(-2.2rem);

        .sxcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #fff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                line-height: 0.44rem;

                text-align: left;
                color: #4e4e4e;
            }
        }

        .zccl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                color: #4e4e4e;

                .des {
                    color: #4e4e4e;
                    text-align: left;

                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.8rem;
                    position: relative;

                    .title {
                        position: absolute;
                        top: -0.5rem;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 2.98rem;
                        height: 0.67rem;
                        line-height: 0.67rem;
                        display: flex;
                        justify-content: center;
                        align-content: center;
                        font-size: 0.32rem;
                        font-weight: bold;
                        color: #ffffff;
                        border-radius: 1rem;
                        background-color: #739bfe;
                    }
                }
            }
        }

        .sbcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.22rem;
                    position: relative;

                    .item {
                        margin-top: 0.35rem;
                        box-sizing: border-box;
                        position: relative;
                        padding-left: 0.42rem;

                        // display: flex;
                        .line {
                            position: absolute;
                            width: 0.02rem;
                            height: 135%;
                            border-left: 0.02rem dashed #739bfe;
                            left: 0.1rem;
                            top: 0.2rem;
                            z-index: 0;
                            //   background-color: #739bfe;
                        }

                        .dot {
                            width: 0.39rem;
                            height: 0.39rem;
                            background-color: #739bfe;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            font-size: 0.28rem;
                            color: #fff;
                            border-radius: 50%;
                            position: absolute;
                            left: -0.1rem;
                            top: 0;
                            z-index: 9999;
                        }

                        .label {
                            font-size: 0.32rem;
                            font-weight: bold;
                            color: #3d5aa3;
                        }
                    }
                }
            }
        }

        .codes {
            margin: 0 auto;
            margin-top: 0.25rem;
            width: 6.85rem;
            background: #fff;
            padding: 0.3rem;
            box-sizing: border-box;
            border-radius: 0.26rem;
            padding-top: 0.28rem;
            font-size: 0.26rem;
            font-weight: 500;
            color: #4e4e4e;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .code {
                width: 1.94rem;
                height: 1.94rem;
            }

            .text {
                width: 4.3rem;
            }
        }
    }
}
</style>
